/** @format */

import React, { useState, useEffect, useMemo } from 'react'
import { _$, Dialog, Button, Select, Option } from '@king-design/react'
import MonitorSearch from 'src/components/MonitorSearch'
import useTableGroup from 'src/hooks/useTableGroup'
import TablePage from 'src/components/TablePage'
import useFormTable from 'src/hooks/useFormTable'
import styled from 'styled-components'
import API from 'src/api/ApiAlarmSilences'
import { QueryKeyEnum } from 'src/utils/unit'

interface TacticsInstancesDialogProps {
  className?: string
  visible: boolean
  ShieldID: number
  onClose: (value: boolean) => void
}

type QueryKey = 'InstanceId' | 'InstanceName' | 'InstanceIP'

const TacticsInstancesDialog: React.FC<TacticsInstancesDialogProps> = ({
  className,
  visible,
  ShieldID,
  onClose
}) => {
  const [queryKey, setQueryKey] = useState<QueryKey>('InstanceId')
  const [query, setQuery] = useState<string>('')
  const regionGroup = useTableGroup('monitorRegionList')
  const [tableGroup, setTableGroup] = useState<{ Region: string }>({ Region: '' })
  const [tableData, setTableData] = useState<any[]>([])
  useEffect(() => {
    if (visible && ShieldID) {
      run({
        PageIndex: 1,
        PageSize: 10
      })
    } else {
      setQuery('')
      setQueryKey('InstanceId')
      setTableGroup({ Region: '' })
      setTableData([])
    }
  }, [visible])

  const { run, total, pageState, loading }: any = useFormTable(
    API.getShieldsInstances,
    {
      manual: true,
      params: {
        ShieldID: ShieldID,
        Region: tableGroup.Region,
        [queryKey]: query
      }
    },
    data => {
      setTableData(data?.Instances || [])
      return {
        tableData: data?.Instances,
        totalCount: data?.TotalCount
      }
    }
  )

  const scheme = useMemo(() => {
    if (regionGroup?.length) {
      const tableScheme = {
        InstanceName: {
          title: _$('实例名称'),
          width: 200
        },
        InstanceIP: {
          title: _$('IP地址'),
          width: 120
        },
        Region: {
          title: _$('Region'),
          width: 150,
          group: regionGroup,
          template(item) {
            const find = regionGroup.find(({ value }) => item.Region === value)
            return find?.label || item.Region
          }
        }
      }
      return tableScheme
    }
    return undefined
  }, [regionGroup])

  return (
    <Dialog
      width={800}
      value={visible}
      mode="destroy"
      onChangeValue={show => {
        !show && onClose(show)
      }}
      title={_$('已绑实例')}
      slotFooter={
        <>
          <Button
            type="primary"
            onClick={() => {
              onClose(false)
            }}
          >
            {_$('关闭')}
          </Button>
        </>
      }
    >
      <div className={className}>
        <div className="header">
          <MonitorSearch
            prepend={
              <React.Fragment>
                <Select
                  value={queryKey}
                  onChangeValue={value => {
                    setQueryKey(value)
                    run({
                      PageIndex: 1,
                      InstanceId: '',
                      InstaceName: '',
                      InstanceIP: '',
                      [value]: query
                    })
                  }}
                  width="120"
                >
                  <Option value="InstanceId">{_$('实例ID')}</Option>
                  <Option value="InstanceName">{_$('实例名称')}</Option>
                  <Option value="InstanceIP">{_$('实例信息')}</Option>
                </Select>
              </React.Fragment>
            }
            width={350}
            placeholder={_$(`请输入${QueryKeyEnum[queryKey]}`)}
            value={query}
            onChange={value => {
              setQuery(value.trim())
              run({
                PageIndex: 1,
                InstanceId: '',
                InstaceName: '',
                InstanceIP: '',
                [queryKey]: value.trim()
              })
            }}
          />
        </div>
        {scheme ? (
          <TablePage
            tableProps={{
              scheme,
              data: tableData,
              checkType: 'none',
              resizable: true,
              group: tableGroup,
              onChangeGroup: value => {
                setTableGroup(value)
                run({
                  PageIndex: 1,
                  Region: value.Region
                })
              }
            }}
            run={run}
            loading={loading}
            pageProps={{ total, ...pageState }}
          />
        ) : null}
      </div>
    </Dialog>
  )
}

export default styled(TacticsInstancesDialog)``
